import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iframe", "form"]
  static values = {
    previewUrl: String,
    debounceMs: { type: Number, default: 1000 }
  }

  connect() {
    this.debounceTimer = null
    this.loadPreview()
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  loadPreview() {
    if (this.hasIframeTarget && this.previewUrlValue) {
      this.iframeTarget.src = this.previewUrlValue
    }
  }

  // Called when any form field changes
  fieldChanged(event) {
    console.log('fieldChanged', event)

    // Clear existing timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    // Set new timer to reload preview after debounce period
    this.debounceTimer = setTimeout(() => {
      this.saveAndRefresh()
    }, this.debounceMs)
  }

  // Save the form and refresh the preview
  async saveAndRefresh() {
    if (!this.hasFormTarget) return

    const form = this.formTarget
    const formData = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: form.method || 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
          'Accept': 'text/html'
        }
      })

      if (response.ok) {
        this.refreshPreview()
      }
    } catch (error) {
      console.error('Error saving form:', error)
    }
  }

  // Manually refresh the preview iframe
  refreshPreview() {
    if (this.hasIframeTarget) {
      // Add timestamp to force reload
      const url = new URL(this.previewUrlValue, window.location.origin)
      url.searchParams.set('_t', Date.now())
      this.iframeTarget.src = url.toString()
    }
  }

  // Toggle preview visibility (for mobile/smaller screens)
  togglePreview(event) {
    const previewContainer = this.element.querySelector('[data-preview-container]')
    if (previewContainer) {
      previewContainer.classList.toggle('d-none')
    }
  }

  // Set desktop view (full width)
  setDesktopView(event) {
    this.setViewSize('100%', event.currentTarget)
  }

  // Set tablet view (768px)
  setTabletView(event) {
    this.setViewSize('768px', event.currentTarget)
  }

  // Set mobile view (375px)
  setMobileView(event) {
    this.setViewSize('375px', event.currentTarget)
  }

  setViewSize(width, activeButton) {
    if (this.hasIframeTarget) {
      this.iframeTarget.style.width = width
      this.iframeTarget.style.margin = width === '100%' ? '0' : '0 auto'
      this.iframeTarget.style.display = 'block'
    }

    // Update active button state
    const buttons = this.element.querySelectorAll('.btn-group .btn')
    buttons.forEach(btn => btn.classList.remove('active'))
    if (activeButton) {
      activeButton.classList.add('active')
    }
  }
}

